<template>
  <div class="app-wrapper">
    <div class="sidebar-container">
      <div class="menu-wrapper">
        <el-menu
          :default-active="$route.path"
          background-color="#304156"
          text-color="#bfcbd9"
          active-text-color="#409EFF"
          router
        >
          <template v-for="menu in menuList">
            <!-- 一级菜单 -->
            <el-menu-item 
              v-if="!menu.children" 
              :key="menu.path"
              :index="menu.path"
            >
              <i :class="menu.icon"></i>
              <span>{{ menu.title }}</span>
            </el-menu-item>
            
            <!-- 二级菜单 -->
            <el-submenu 
              v-else 
              :key="menu.index"
              :index="menu.index"
            >
              <template #title>
                <i :class="menu.icon"></i>
                <span>{{ menu.title }}</span>
              </template>
              <el-menu-item 
                v-for="subMenu in menu.children" 
                :key="subMenu.path"
                :index="subMenu.path"
              >
                {{ subMenu.title }}
              </el-menu-item>
            </el-submenu>
          </template>
        </el-menu>
      </div>
    </div>
    <div class="main-container">
      <div class="navbar">
        <div class="right-menu">
          <el-dropdown trigger="click">
            <span class="el-dropdown-link">
              管理员<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
      <div class="app-main">
        <router-view />
      </div>
      
      <!-- 备案号 -->
      <div class="icp-info">
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
          粤ICP备2024298707号
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Layout',
  data() {
    return {
      menuList: [
        {
          path: '/dashboard',
          title: '首页',
          icon: 'el-icon-s-home'
        },
        {
          index: '1',
          title: '文章管理',
          icon: 'el-icon-document',
          children: [
            {
              path: '/article/list',
              title: '文章列表'
            },
            {
              path: '/article/category',
              title: '分类管理'
            }
          ]
        },
        {
          index: '2',
          title: 'APP配置',
          icon: 'el-icon-setting',
          children: [
            {
              path: '/app-config/banner',
              title: '轮播图管理'
            },
            {
              path: '/app-config/grid-menu',
              title: '九宫格菜单'
            },
            {
              path: '/app-config/index',
              title: '其他配置'
            }
          ]
        },
        {
          index: '3',
          title: '挖空管理',
          icon: 'el-icon-edit',
          children: [
            {
              path: '/memory/category',
              title: '分类管理'
            },
            {
              path: '/memory/article',
              title: '文章管理'
            }
          ]
        },
        {
          index: '4',
          title: '题库管理',
          icon: 'el-icon-collection',
          children: [
            {
              path: '/question/category',
              title: '题库分类'
            },
            {
              path: '/question/bank',
              title: '题库管理'
            },
            {
              path: '/question/correction',
              title: '纠错记录'
            }
          ]
        },
        {
          index: '5',
          title: '用户管理',
          icon: 'el-icon-collection',
          children: [
            {
              path: '/system/app-user',
              title: '移动端用户'
            },
            {
              path: '/system/redeem',
              title: '兑换码管理'
            }
          ]
        },
        {
          index: '6',
          title: '商城管理',
          icon: 'el-icon-shopping-cart-2',
          children: [
            {
              path: '/shop/product',
              title: '商品管理'
            },
            {
              path: '/shop/top-section',
              title: '顶部资料专区'
            },
            {
              path: '/shop/service-guarantee',
              title: '服务保障配置'
            }
          ]
        },
        {
          index: '7',
          title: '系统管理',
          icon: 'el-icon-s-tools',
          children: [
            {
              path: '/system/config',
              title: '系统配置'
            },
            {
              path: '/system/agreement',
              title: '协议管理'
            },
            {
              path: '/system/version',
              title: '版本管理'
            }
          ]
        }
      ]
    }
  },
  methods: {
    logout() {
      localStorage.removeItem('token')
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="scss" scoped>
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden;
}

.app-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  overflow: hidden;
}

.sidebar-container {
  width: 210px;
  height: 100%;
  background: #304156;
  
  .menu-wrapper {
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    
    // 自定义滚动条样式
    &::-webkit-scrollbar {
      width: 6px;
    }
    
    &::-webkit-scrollbar-track {
      background: #2c3e50;
    }
    
    &::-webkit-scrollbar-thumb {
      background: #4a5568;
      border-radius: 3px;
      
      &:hover {
        background: #5a6578;
      }
    }
  }
  
  .el-menu {
    border: none;
    height: auto;
    min-height: 100%;
    width: 100%;
  }
}

.main-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.navbar {
  height: 50px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  display: flex;
  align-items: center;
  padding: 0 20px;
  
  .right-menu {
    margin-left: auto;
    
    .el-dropdown-link {
      cursor: pointer;
      color: #606266;
      
      &:hover {
        color: #409EFF;
      }
    }
  }
}

.app-main {
  flex: 1;
  overflow: auto;
  background: #f0f2f5;
}

.icp-info {
  position: fixed;
  bottom: 10px;
  right: 20px;
  z-index: 1000;
  
  a {
    color: #909399;
    text-decoration: none;
    font-size: 12px;
    
    &:hover {
      color: #409EFF;
    }
  }
}
</style> 